// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3W_E8","legacyBtn":"MutateMid_legacyBtn__2BEtI"};